import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import "../../../Assets/Css/Department.scss";
import { IoCloudUploadOutline } from 'react-icons/io5';


const initialState = {
    title: null,
};

const DocumentTypes = [
    { value: 'Aadhar Card', label: 'Aadhar Card' },
    { value: 'PAN Card', label: 'PAN Card' },
    { value: 'Driving Licence', label: 'Driving Licence' },
    { value: 'Passbook', label: 'Passbook' },
    { value: 'Photograph', label: 'Photograph' },
];

function EmpAddDocumentModal({ isModalVisible, closeModal }) {
    const [clientData, setClientData] = useState(initialState);

    return (
        <Modal show={isModalVisible} onHide={closeModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered className="custom-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className='heading'>Add Request For Project</h5>
                    <button className="btn-close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <div className='empadd-document-container'>
                        <div className='add-information-part'>
                            <div className='form-part'>
                                <form>
                                    <div className="form-group">
                                        <div className='row'>

                                            <div className="col-lg-12">
                                                <div className="input-group">
                                                    <h6 className='label'>Select Document</h6>
                                                    <Select
                                                        options={DocumentTypes}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={clientData.title}
                                                        placeholder="---"
                                                        onChange={(val) => {
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                title: val
                                                            }));
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="input-group">
                                                    <label className="label">Select Files</label>
                                                    <div className="file-upload-wrapper">
                                                        <label htmlFor="file-upload" className="file-upload-label">
                                                            <IoCloudUploadOutline />
                                                            <p>Select Files</p>
                                                            <span className='label'>Drop files here or click browse thorough your machine</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="file-upload"
                                                            className="file-upload-input"
                                                            name="photos"
                                                            multiple
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-end">
                    <button className="btn-cancel" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn-save" onClick={closeModal}>
                        Add Request For Project
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default EmpAddDocumentModal;
